import { defineFetch } from 'resift';
import { WidgetLayoutCreateOrUpdateRequest } from 'pages/Homepage/typings';

const makeCreateWidgetLayout = defineFetch({
  displayName: 'Create a Widget Layout',
  make: () => ({
    request: (data: WidgetLayoutCreateOrUpdateRequest) => ({ http }) =>
      http({
        method: 'POST',
        route: '/homepage-layouts',
        data,
      }),
  }),
});

const createWidgetLayout = makeCreateWidgetLayout();

export default createWidgetLayout;
